/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIManualShareJSONRequest } from './APIManualShareJSONRequest';
import {
    APIManualShareJSONRequestFromJSON,
    APIManualShareJSONRequestFromJSONTyped,
    APIManualShareJSONRequestToJSON,
} from './APIManualShareJSONRequest';
import type { APIAutomaticShareJsonRequest } from './APIAutomaticShareJsonRequest';
import {
    APIAutomaticShareJsonRequestFromJSON,
    APIAutomaticShareJsonRequestFromJSONTyped,
    APIAutomaticShareJsonRequestToJSON,
} from './APIAutomaticShareJsonRequest';

/**
 * A collection of serializer extensions, which allow for:
 * 
 * * Blacklisting fields through an "exclude" context variable
 * * Whitelisting fields through an "only" context variable
 * * Expanding related fields through an "expand" context variable
 * * Other helper methods
 * 
 * Blacklisting and whitelisting takes precedence over expanding, and can
 * be used in combination with one another.
 * @export
 * @interface APIPatchedSharepointUpdateRequest
 */
export interface APIPatchedSharepointUpdateRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof APIPatchedSharepointUpdateRequest
     */
    articles?: Array<string>;
    /**
     * 
     * @type {Array<APIAutomaticShareJsonRequest>}
     * @memberof APIPatchedSharepointUpdateRequest
     */
    automaticShares?: Array<APIAutomaticShareJsonRequest>;
    /**
     * 
     * @type {Array<APIManualShareJSONRequest>}
     * @memberof APIPatchedSharepointUpdateRequest
     */
    manualShares?: Array<APIManualShareJSONRequest>;
    /**
     * 
     * @type {number}
     * @memberof APIPatchedSharepointUpdateRequest
     */
    shareDuration?: number;
}

/**
 * Check if a given object implements the APIPatchedSharepointUpdateRequest interface.
 */
export function instanceOfAPIPatchedSharepointUpdateRequest(value: object): value is APIPatchedSharepointUpdateRequest {
    return true;
}

export function APIPatchedSharepointUpdateRequestFromJSON(json: any): APIPatchedSharepointUpdateRequest {
    return APIPatchedSharepointUpdateRequestFromJSONTyped(json, false);
}

export function APIPatchedSharepointUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPatchedSharepointUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'articles': json['articles'] == null ? undefined : json['articles'],
        'automaticShares': json['automatic_shares'] == null ? undefined : ((json['automatic_shares'] as Array<any>).map(APIAutomaticShareJsonRequestFromJSON)),
        'manualShares': json['manual_shares'] == null ? undefined : ((json['manual_shares'] as Array<any>).map(APIManualShareJSONRequestFromJSON)),
        'shareDuration': json['share_duration'] == null ? undefined : json['share_duration'],
    };
}

export function APIPatchedSharepointUpdateRequestToJSON(value?: APIPatchedSharepointUpdateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'articles': value['articles'],
        'automatic_shares': value['automaticShares'] == null ? undefined : ((value['automaticShares'] as Array<any>).map(APIAutomaticShareJsonRequestToJSON)),
        'manual_shares': value['manualShares'] == null ? undefined : ((value['manualShares'] as Array<any>).map(APIManualShareJSONRequestToJSON)),
        'share_duration': value['shareDuration'],
    };
}

